import { render } from "./AddPassword.vue?vue&type=template&id=0ef5ec14"
import script from "./AddPassword.vue?vue&type=script&lang=js"
export * from "./AddPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__